import CrudTable from '../../components/CrudTable';

// QT#2: bộ hướng dẫn sử dụng cho nhân viên + script bán hàng.
export default function DocsAdmin() {
  return (
    <CrudTable
      title="📚 Hướng dẫn nhân viên & script bán hàng"
      table="staff_docs"
      orderBy="sort_order"
      ascending
      defaults={{ doc_type: 'guide', sort_order: 0 }}
      columns={[
        { key: 'doc_type', label: 'Loại', type: 'select', required: true, options: [
            { value: 'guide', label: '📖 Hướng dẫn' },
            { value: 'script', label: '🗣️ Script bán hàng' },
          ] },
        { key: 'title', label: 'Tiêu đề', type: 'text', required: true },
        { key: 'body', label: 'Nội dung', type: 'textarea', render: (r) => (
            <details>
              <summary>Xem nội dung</summary>
              <div style={{ whiteSpace: 'pre-line', marginTop: 6, maxWidth: 480 }}>{r.body}</div>
            </details>
          ) },
        { key: 'sort_order', label: 'Thứ tự', type: 'number' },
      ]}
    />
  );
}
